import { Checkbox } from "@/components/ui/input/checkbox";
import classNames from "classnames";
import {
  createElement,
  FC,
  isValidElement,
  MouseEvent,
  ReactNode,
} from "react";
import { DropdownListDataType } from "../types";

interface ListItemType {
  className?: string;
  menu: DropdownListDataType;
  value?: DropdownListDataType | DropdownListDataType[];
  highlightSelected?: boolean;
  checkbox?: boolean;
  iconClassName?: string;
  onSelect?: (data: any) => void;
}

const renderIcon = (icon: any) => {
  try {
    const IconComponent = icon;
    return createElement(IconComponent, null);
  } catch (error) {
    return "";
  }
};

const ListItem: FC<ListItemType> = ({
  menu,
  className,
  checkbox,
  iconClassName,
  onSelect,
  value,
}) => {
  const handleEvent = (e: MouseEvent<HTMLDivElement>) => {
    try {
      e?.preventDefault();
      e?.stopPropagation();

      if (menu?.event) {
        menu?.event(menu);
      }

      if (onSelect) {
        onSelect(menu);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const isSelected = (): boolean => {
    try {
      if (Array.isArray(value)) {
        return Boolean(value?.find((item) => item?.title === menu?.title));
      } else {
        return value?.title === menu?.title;
      }
    } catch (error) {
      return false;
    }
  };

  const ListTitle = () => (
    <div className="flex items-center gap-2">
      {menu?.icon && (
        <div
          className={classNames(
            "menu-item-icon-container relative max-w-max [&>svg]:w-4 [&>svg]:h-4",
            iconClassName
          )}
        >
          {typeof menu?.icon === "string" ? (
            <img
              src={menu?.icon ? menu?.icon : ""}
              alt={menu?.icon ?? "menu-icon"}
              className="menu-item-icon w-4 h-4 object-contain"
            />
          ) : isValidElement(menu?.icon) ? (
            <>{menu?.icon}</>
          ) : (
            typeof menu?.icon === "object" && (
              <>{renderIcon(menu?.icon as ReactNode)}</>
            )
          )}
        </div>
      )}
      {menu?.title && (
        <div className="menu-item-title flex-1 capitalize text-sm whitespace-nowrap">
          {menu?.title}
        </div>
      )}
    </div>
  );

  return (
    <div
      title={menu?.title}
      role="button"
      className={classNames(
        "menu-item w-full flex items-center gap-2 px-3 hover:bg-slate-100 cursor-pointer last-of-type:mb-3 py-1.5",
        isSelected() && "bg-main/10 hover:!bg-main/10",
        className
      )}
      onClick={(e) => handleEvent(e)}
    >
      {checkbox ? (
        <Checkbox
          id={menu?.title}
          label={<ListTitle />}
          checked={Boolean(menu?.checked) || isSelected()}
        />
      ) : (
        <ListTitle />
      )}
    </div>
  );
};

export default ListItem;
